/* Private-link gate. The public journey is vault door → showcase → contact us; the real
   login is only reachable via /login?key=vault, which flags the device so the customer
   never needs the link again. Obscurity, not security — the backend still authenticates. */
export const ACCESS_WORD = "vault";
const KEY = "armorbatch_access";

export const grantAccess = () => { try { localStorage.setItem(KEY, "1"); } catch { /* private mode */ } };
export const hasAccess = () => { try { return !!localStorage.getItem(KEY); } catch { return false; } };
